const DATE_ONLY_PREFIX = /^(\d{4}-\d{2}-\d{2})/

export function parseDateOnlyToLocal(value?: string | null): Date | null {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed) return null
  const match = trimmed.match(DATE_ONLY_PREFIX)
  if (match) {
    const [year, month, day] = match[1].split('-').map(Number)
    const date = new Date(year, month - 1, day)
    return Number.isNaN(date.getTime()) ? null : date
  }
  const parsed = new Date(trimmed)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

export function formatDateRangeDateOnly(
  start?: string | null,
  end?: string | null,
  fallback = 'Dates TBA'
): string {
  const startDate = parseDateOnlyToLocal(start)
  const endDate = parseDateOnlyToLocal(end)
  if (!startDate || !endDate) return fallback
  return `${startDate.toLocaleDateString()} – ${endDate.toLocaleDateString()}`
}

export function normalizeDateInputValue(value?: string | null): string {
  if (!value) return ''
  const trimmed = value.trim()
  if (!trimmed) return ''
  const match = trimmed.match(DATE_ONLY_PREFIX)
  if (match) return match[1]
  const parsed = parseDateOnlyToLocal(trimmed)
  if (!parsed) return ''
  const year = parsed.getFullYear()
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const day = String(parsed.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function toApiDateOnly(value?: string | null): string | undefined {
  if (value === undefined || value === null) return undefined
  const trimmed = value.trim()
  if (!trimmed) return undefined
  const match = trimmed.match(DATE_ONLY_PREFIX)
  if (match) return match[1]
  const parsed = parseDateOnlyToLocal(trimmed)
  if (!parsed) return undefined
  const year = parsed.getFullYear()
  const month = String(parsed.getMonth() + 1).padStart(2, '0')
  const day = String(parsed.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** The calendar date where the reader is, for comparison with date-only values. */
export function localDateOnly(date = new Date()): string {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}
